import axios from 'axios';
import { getAuthHeader } from '../utils/auth';

const API_URL = process.env.REACT_APP_API_URL + 'packagings';

export const getPackagings = async () => {
  const response = await axios.get(API_URL, { headers: getAuthHeader() });
  return response.data;
};
export const getPriceList = async () => {
  const response = await axios.get(API_URL + '/price-list', { headers: getAuthHeader() });
  return response.data;
};
export const getPackaging = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`, { headers: getAuthHeader() });
  return response.data;
};

export const createPackaging = async (packaging) => {
  const response = await axios.post(API_URL, packaging, { headers: getAuthHeader() });
  return response.data;
};

export const updatePackaging = async (id, packaging) => {
  const response = await axios.put(`${API_URL}/${id}`, packaging, { headers: getAuthHeader() });
  return response.data;
};

export const deletePackaging = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}`, { headers: getAuthHeader() });
  return response.data;
};

export const updateOrder = async (data) => {
  const response = await axios.put(`${API_URL}/order`, data, { headers: getAuthHeader() });
  return response.data;
};
